import { stateToTimezone, timezoneToRegion } from "./timezoneMap";

// Get timezone for a given ZIP code.
export const getTimezoneByStateCode = (
  countryCode: string,
  stateCode: string
): string[] | undefined => {
  const timezoneMap = stateToTimezone[countryCode.toUpperCase()];
  if (!timezoneMap) {
    return undefined;
  }

  return timezoneMap[stateCode.toUpperCase()];
};

export const getTimezoneRegionByTimezone = (
  countryCode: string,
  timezone: string
): string => {
  const timezoneMap = timezoneToRegion[countryCode.toUpperCase()];

  if (!timezoneMap) {
    return timezone;
  }

  return timezoneMap[timezone] || timezone;
};

export const getTimezoneRegionByStateCode = (
  countryCode: string,
  stateCode?: string
): string | undefined => {
  if (!stateCode) {
    return undefined;
  }

  const timezone = getTimezoneByStateCode(countryCode, stateCode);

  return timezone
    ? getTimezoneRegionByTimezone(countryCode, timezone[0]) // use only primary timezone is the state has multiple timezones
    : undefined;
};
